// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.itatopbar-inline-1 {
  display: flex;
  align-items: center;
  gap: 6px;
}

.itatopbar-inline-2 {
  cursor: pointer;
}

.itatopbar-inline-3 {
  position: relative;
}

.itatopbar-inline-4 {
  cursor: pointer;
  position: relative;
}

.itatopbar-inline-5 {
  position: absolute;
  top: 2px;
  right: 2px;
  min-width: 16px;
  height: 16px;
  background: #ef4444;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 9px;
  font-weight: 800;
  color: #fff;
  padding: 0 4px;
  border: 2px solid #fff;
}

.itatopbar-inline-6 {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  width: 380px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 12px 40px rgba(0,0,0,.15);
  z-index: 9999;
  overflow: hidden;
}

.itatopbar-inline-7 {
  padding: 14px 16px;
  border-bottom: 1px solid #f1f5f9;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.itatopbar-inline-8 {
  font-size: 14px;
  font-weight: 700;
  color: #1e293b;
}

.itatopbar-inline-9 {
  font-size: 11px;
  color: #94a3b8;
}

.itatopbar-inline-10 {
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 6px;
  padding: 4px 10px;
  font-size: 11px;
  font-weight: 600;
  color: #2563eb;
  cursor: pointer;
}

.itatopbar-inline-11 {
  max-height: 350px;
  overflow-y: auto;
}

.itatopbar-inline-12 {
  text-align: center;
  padding: 30px;
  color: #94a3b8;
  font-size: 12px;
}

.itatopbar-inline-13 {
  width: 8px;
  padding-top: 6px;
  flex-shrink: 0;
}

.itatopbar-inline-14 {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #6366f1;
}

.itatopbar-inline-15 {
  flex: 1 1;
  min-width: 0;
}

.itatopbar-inline-16 {
  font-size: 11px;
  color: #94a3b8;
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.itatopbar-inline-17 {
  display: flex;
  gap: 8px;
  margin-top: 4px;
  align-items: center;
}

.itatopbar-inline-18 {
  font-size: 10px;
  color: #94a3b8;
}

.itatopbar-inline-19 {
  padding: 10px 16px;
  border-top: 1px solid #f1f5f9;
  text-align: center;
  font-size: 12px;
  font-weight: 600;
  color: #6366f1;
  cursor: pointer;
  background: #fafbff;
}

.itatopbar-inline-20 {
  cursor: pointer;
}

.itatopbar-dyn-1 {
  padding: 10px 16px;
  border-bottom: 1px solid #f8fafc;
  background: var(--itatopbar-1-background);
  cursor: var(--itatopbar-1-cursor);
  display: flex;
  gap: 10px;
  align-items: flex-start;
}

.itatopbar-dyn-2 {
  font-size: 12px;
  font-weight: var(--itatopbar-2-font-weight);
  color: var(--itatopbar-2-color);
  margin-bottom: 2px;
}

.itatopbar-dyn-3 {
  font-size: 9px;
  font-weight: 700;
  padding: 1px 6px;
  border-radius: 8px;
  background: var(--itatopbar-3-background);
  color: var(--itatopbar-3-color);
  text-transform: capitalize;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/ITAdmin/ITATopbar.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,uCAAuC;EACvC,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,yCAAyC;EACzC,iCAAiC;EACjC,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,2CAA2C;EAC3C,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,+BAA+B;EAC/B,0BAA0B;AAC5B","sourcesContent":[".itatopbar-inline-1 {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.itatopbar-inline-2 {\n  cursor: pointer;\n}\n\n.itatopbar-inline-3 {\n  position: relative;\n}\n\n.itatopbar-inline-4 {\n  cursor: pointer;\n  position: relative;\n}\n\n.itatopbar-inline-5 {\n  position: absolute;\n  top: 2px;\n  right: 2px;\n  min-width: 16px;\n  height: 16px;\n  background: #ef4444;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 9px;\n  font-weight: 800;\n  color: #fff;\n  padding: 0 4px;\n  border: 2px solid #fff;\n}\n\n.itatopbar-inline-6 {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  width: 380px;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  box-shadow: 0 12px 40px rgba(0,0,0,.15);\n  z-index: 9999;\n  overflow: hidden;\n}\n\n.itatopbar-inline-7 {\n  padding: 14px 16px;\n  border-bottom: 1px solid #f1f5f9;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.itatopbar-inline-8 {\n  font-size: 14px;\n  font-weight: 700;\n  color: #1e293b;\n}\n\n.itatopbar-inline-9 {\n  font-size: 11px;\n  color: #94a3b8;\n}\n\n.itatopbar-inline-10 {\n  background: #eff6ff;\n  border: 1px solid #bfdbfe;\n  border-radius: 6px;\n  padding: 4px 10px;\n  font-size: 11px;\n  font-weight: 600;\n  color: #2563eb;\n  cursor: pointer;\n}\n\n.itatopbar-inline-11 {\n  max-height: 350px;\n  overflow-y: auto;\n}\n\n.itatopbar-inline-12 {\n  text-align: center;\n  padding: 30px;\n  color: #94a3b8;\n  font-size: 12px;\n}\n\n.itatopbar-inline-13 {\n  width: 8px;\n  padding-top: 6px;\n  flex-shrink: 0;\n}\n\n.itatopbar-inline-14 {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: #6366f1;\n}\n\n.itatopbar-inline-15 {\n  flex: 1;\n  min-width: 0;\n}\n\n.itatopbar-inline-16 {\n  font-size: 11px;\n  color: #94a3b8;\n  line-height: 1.3;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.itatopbar-inline-17 {\n  display: flex;\n  gap: 8px;\n  margin-top: 4px;\n  align-items: center;\n}\n\n.itatopbar-inline-18 {\n  font-size: 10px;\n  color: #94a3b8;\n}\n\n.itatopbar-inline-19 {\n  padding: 10px 16px;\n  border-top: 1px solid #f1f5f9;\n  text-align: center;\n  font-size: 12px;\n  font-weight: 600;\n  color: #6366f1;\n  cursor: pointer;\n  background: #fafbff;\n}\n\n.itatopbar-inline-20 {\n  cursor: pointer;\n}\n\n.itatopbar-dyn-1 {\n  padding: 10px 16px;\n  border-bottom: 1px solid #f8fafc;\n  background: var(--itatopbar-1-background);\n  cursor: var(--itatopbar-1-cursor);\n  display: flex;\n  gap: 10px;\n  align-items: flex-start;\n}\n\n.itatopbar-dyn-2 {\n  font-size: 12px;\n  font-weight: var(--itatopbar-2-font-weight);\n  color: var(--itatopbar-2-color);\n  margin-bottom: 2px;\n}\n\n.itatopbar-dyn-3 {\n  font-size: 9px;\n  font-weight: 700;\n  padding: 1px 6px;\n  border-radius: 8px;\n  background: var(--itatopbar-3-background);\n  color: var(--itatopbar-3-color);\n  text-transform: capitalize;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
